import palette from '../palette';

const muiInputBaseOverrides = {
  styleOverrides: {
    root: {
      color: palette.text.secondary,
    },
  },
};

export default muiInputBaseOverrides;
